import { createFileRoute } from '@tanstack/react-router'
import { CardRegisterPage } from '@/features/payment/CardRegisterPage'

export const Route = createFileRoute('/payment/card-register/$token')({
  component: CardRegisterComponent,
})

function CardRegisterComponent() {
  const { token } = Route.useParams()
  
  return <CardRegisterPage token={token} />
}